module.exports = {"id":"211891","name":"Andreas Voglsammer","rating":"72","photo":"./data/images/photos/2/211891.png","club":{"name":"Arminia Bielefeld","logo":"./data/images/clubs/ArminiaBielefeld.png"},"positions":["BU","MD","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndreasVoglsammer0.json
// module id = 382
// module chunks = 0